import { render } from "./jobSelection.vue?vue&type=template&id=652dccc0&scoped=true"
import script from "./jobSelection.vue?vue&type=script&lang=js"
export * from "./jobSelection.vue?vue&type=script&lang=js"

import "./jobSelection.vue?vue&type=style&index=0&id=652dccc0&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652dccc0"]])

export default __exports__